import React from 'react'
import {useIntl} from 'react-intl'
import {InputSearch, TableHeader} from '../../../../../../_gori/partials/widgets'

const UserManagementFilter: React.FC = () => {
  const intl = useIntl()

  return (
    <>
      <TableHeader className='min-h-1px my-5 mb-6 d-flex flex-column'>
        <div className='card-toolbar flex-row-fluid justify-content-between align-items-start'>
          <div className='d-flex align-items-center position-relative'>
            <InputSearch placeholder={intl.formatMessage({id: 'SEARCH_USERS'})} />
          </div>
        </div>
      </TableHeader>
    </>
  )
}

export {UserManagementFilter}
